import { clsx } from 'clsx'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const JourneyThumbnailPlaceholder = ({ className }: { className?: string }) => (
  <Placeholder
    className={clsx('h-64 flex-col justify-end p-4 gap-4', className)}
    testID={TEST_ID.PRAYER_SPACE.JOURNEY_SLIDER_PLACEHOLDER}
  >
    <View className="gap-2">
      <View className="flex-row gap-2">
        <PlaceholderLine contrast="dark" className="w-24 h-7 rounded-md" />
        <PlaceholderLine contrast="dark" className="w-24 h-7 rounded-md" />
      </View>
      <View className="gap-1">
        <PlaceholderLine contrast="dark" size="md" />
        <PlaceholderLine length="half" contrast="dark" size="md" />
      </View>
    </View>
    <PlaceholderLine contrast="dark" className="animate-pulse h-2" />
  </Placeholder>
)
